import { IBSLoookups, IIBSRequestForm } from '@interfaces/IBSRequest';
import { ACCESS_TOKEN, Core, IBS_LOOKUPS, IBS_REQUEST_SUBMIT } from '@services/Core';
import { AxiosPromise } from 'axios';

const IBS_REQUEST_TOKEN = process.env.REACT_APP_IBS_REQUEST_TOKEN;

interface GetAccessToken {
  (): AxiosPromise<{ access_token: string }>;
}

interface IBSLookups {
  (token: string): AxiosPromise<IBSLoookups>;
}

interface IBSSubmit {
  (data: IIBSRequestForm, token: string): AxiosPromise;
}

class IBSRequest extends Core {
  getAccessToken: GetAccessToken = async () => {
    const formData = new URLSearchParams();
    formData.append('grant_type', 'client_credentials');
    return this.post(`${ACCESS_TOKEN}`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Basic ${IBS_REQUEST_TOKEN}`,
      },
      transformRequest: [
        (data, headers) => {
          headers['Content-Type'] = 'application/x-www-form-urlencoded';
          return data;
        },
      ],
    });
  };
  getIBSLookups: IBSLookups = async (token: string) => {
    return this.get(IBS_LOOKUPS(), {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  };
  submitIBSRequest: IBSSubmit = async (data, token) =>
    this.post(IBS_REQUEST_SUBMIT(), data, {
      headers: { Authorization: `Bearer ${token}` },
    });
}

export const ibsRequest = new IBSRequest();
